import { fieldRef, rateNodeFromSource, op } from './astHelpers';

/** Percentage: PERCENTAGE(base, rate) */
export const buildPercentageFormula = (cfg = {}) => {
  if (!cfg.baseFieldCode) return null;
  return op('PERCENTAGE', [fieldRef(cfg.baseFieldCode), rateNodeFromSource(cfg)]);
};
